import {ShapeCommand} from '../commands.template';
import {IActImageJson, IActJson} from '../../diagram-data/diagram-json-handler.service';
import * as _ from 'lodash';

export class ActivityChangeImageCommand extends ShapeCommand {
  private static ACT_MIN_WIDTH = 100;
  private static ACT_MIN_HEIGHT = 72;

  protected services: any;
  private old: IActImageJson;
  public object: IActImageJson;

  constructor(data: IActImageJson) {
    super(data);
  }

  public prepareData() {
    const act = this.getActJson(this.object.mxKey);

    this.old = {
      mxKey: this.object.mxKey,
      image: act.image || null, // JSON handler ignores undefined keys
      imageUrl: act.imageUrl || null,
      position: act.position
    };

    return this;
  }

  private changeActImage(change: IActImageJson) {
    const action = {
      changeActivity: {
        mxKey: change.mxKey,
        image: change.image
      }
    };
    /** honestly, this is retarded, sorry **/
    const UIAction = _.cloneDeep(action);

    UIAction.changeActivity['imageUrl'] = change.imageUrl;
    this.services.jsonHandlerSvc.update(UIAction);
    this.services.diagramUpdateSvc.update(action, false, true);
    this.changeCell(change.mxKey, change.position);
  }

  private getActJson(mxKey: number): IActJson {
    return this.services.jsonHandlerSvc
      .get()
      .activities.find(a => Number(a.mxKey) === Number(mxKey));
  }

  private changeCell(mxKey: number, currPos) {
    const newPos = {
      height: Math.max(currPos.h, ActivityChangeImageCommand.ACT_MIN_HEIGHT),
      width: Math.max(currPos.w, ActivityChangeImageCommand.ACT_MIN_WIDTH),
      x: currPos.x,
      y: currPos.y
    };
    const cell = this.services.graphHelperSvc
      .allActivities()
      .find(actCell => Number(actCell.id) === Number(mxKey));

    cell.comp.instance.setupFromJson();
    cell.comp.instance.setImageMode(true);
    cell.skipUndo = true;
    this.services.editorRegistrySvc.getGraph().cellResized(cell, newPos, false, false);
  }

  public execute() {
    super.execute();
    this.changeActImage(this.object);
  }

  public reverse() {
    super.reverse();
    this.changeActImage(this.old);
  }
}
